export default "__VITE_ASSET__TEDN0mcZ__"